// extracted by mini-css-extract-plugin
export default {"shared":"'../../../shared.module.css'","md":"768px","chooseManyContainer":"ChooseMany_chooseManyContainer__5UxsD","checked":"ChooseMany_checked__dgaGz"};